import { createReducer } from '@reduxjs/toolkit'

import { receivedReservation } from '../actions/actions'
import { translateTicket } from '../utils/serialTickets'

const initialState = null

const reservation = createReducer(initialState, {
  [receivedReservation]: (state, { payload }) => ({
    ...payload,
    serialTickets: payload.serialTickets.map(translateTicket)
  })
})

export default reservation
